/***
 *
 *   STATUS BUCKET SETTINGS PANEL
 *   Send-email toggle for a status template bucket. Kept as a pannel (live
 *   behavior); chrome aligned with the rest of Phase 6.
 *
 **********/

import React, { useContext } from 'react';
import { Form, TitleRow, ViewContext } from 'components/lib';
import { useTranslate } from 'app/translations';
import Style from './settings.tailwind';

export const StatusSettings = (props) => {
    const { statusTemplate, updateTicketStatusMutation, columnId } = props;
    const viewContext = useContext(ViewContext);
    const { _t } = useTranslate();

    const index = statusTemplate.findIndex((status) => status.key === columnId);
    const current = index >= 0 ? statusTemplate[index] : null;
    const defaultValue = current?.send_email ? 'yes' : 'no';

    const formData = {
        send_email: {
            label: _t('table.actions.mail'),
            type: 'radio',
            options: ['yes', 'no'],
            default: defaultValue,
            required: true,
        },
    };

    const mutateData = (data) => {
        if (index < 0) return;
        const next = statusTemplate.map((status, i) =>
            i === index
                ? {
                      ...status,
                      send_email: data.send_email === 'yes' || data.send_email === 'Yes',
                  }
                : status,
        );
        updateTicketStatusMutation.mutate({ status_template: next });
    };

    return (
        <div className={Style.container}>
            <div className={Style.header}>
                <TitleRow title={`${_t('settings.label')}: ${props.title}`} />
            </div>
            <div className={Style.main}>
                <div className={Style.emails}>
                    <h2 className={Style.subTitle}>{_t('ticket.history.email')}</h2>
                    <p className={Style.hint}>{_t('ticket.category.status.sendEmailHint')}</p>
                    <Form
                        data={formData}
                        callback={(data) => {
                            viewContext.pannel.hide(true);
                            mutateData(data);
                        }}
                        buttonText={_t('save')}
                    />
                </div>
            </div>
        </div>
    );
};
